import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY } from '@/modules/user/components/ManageProfile/components/Dependents/queries/useDependents.query';

const useRemoveDependentQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isSuccess } = useMutation(
    (id: string) => api.put(API_URL.V2_DEPENDENTS_DEACTIVATE_BY_DEPENDENT_ID(id)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_DEPENDENTS_BY_EMPLOYEE_ID_KEY] });
      },
    }
  );
  return {
    removeDependent: mutateAsync,
    isLoading,
    isSuccess,
  };
};

export default useRemoveDependentQuery;
